/* CSS */
import styles from './PresenceAvatars.module.css';

/* A row of overlapping avatars for members currently viewing this trip */
export function PresenceAvatars({ roster, editingIds = [] }) {

    if (roster.length === 0) return null;

    return (
        <div className={styles.stack}>
            {roster.map(person => {
                const isEditing = editingIds.includes(person.userId);
                return (
                    <div
                        key={person.userId}
                        className={`${styles.avatar} ${isEditing ? styles.editing : ''}`}
                        data-tooltip={isEditing ? `${person.name} is editing…` : person.name}
                    >
                        <div className={styles.avatarCircle}>
                            {/* Falls back to an initial when there's no avatar image */}
                            {person.avatar
                                ? <img src={person.avatar} alt={person.name} className={styles.image} />
                                : <span className={styles.initials}>{(person.name || '?').charAt(0).toUpperCase()}</span>}
                        </div>
                    </div>
                )
            })}
        </div>
    );
}
